import { Injectable } from '@angular/core';
import { ConfiguracaoAndroid } from 'src/app/core/modelos/Android/ConfiguracaoAndroid'; // Importe seu modelo
//import { AppConfigService } from './app-config.service'; // Importe o serviço de configuração
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class EndpointService {

  // Injetamos o AppConfigService para ter acesso às configurações carregadas do config.json
  // constructor(private appConfig: AppConfigService) { }

  public getMaestroUrl(): string {

    // let maestroUrl = this.appConfig.settings.baseApiUrlDiscovery;
    let maestroUrl = environment.baseApiUrlDiscovery;

    const configStorage = localStorage.getItem("configuracao");
    if (configStorage) {
      try {
        const config: ConfiguracaoAndroid = JSON.parse(configStorage);
        if (config?.url && config.ativo) {
          maestroUrl = config.url;
        }
      } catch (e) {
        console.error("Erro ao processar a configuração do localStorage", e);
      }
    }

    if (maestroUrl && maestroUrl.lastIndexOf("/") !== maestroUrl.length - 1) {
      maestroUrl += "/";
    }
    
    return maestroUrl;
  }
}